@let location = defaultLocation$ | async;

<h1 mat-dialog-title>{{ 'asset.select_default_location' | transloco }}</h1>
<mat-dialog-content>
    @if (location) {
        <loren-base-map
                [location]="location"
                [scrollWheelZoom]="true"
                [enableDrag]="true"
                [createMarkerOnClick]="true"
                [mapHeight]="400"
                (markerDragEnd)="handleDragEnd($event)"
                (markerPositioned)="handlePositionChange($event)" />
    }
</mat-dialog-content>
<mat-dialog-actions align="end">
    <button mat-button (click)="cancelClick()">
        {{ 'operations.cancel' | transloco }}
    </button>
    <button mat-stroked-button (click)="saveClick()" color="primary">
        {{ 'operations.save' | transloco }}
    </button>
</mat-dialog-actions>
